<p-dialog [draggable]="false" [resizable]="false" [(visible)]="visible"
    [style]="{ width: '29.071rem' }" (onHide)="handleHide()">
    <div class="web-center">
        <div>
            <img src="assets/images/mail-sent-icon.png" style="height: 48px;width: 48px;" alt="">
        </div>
        <div class="signup-done mt-4">
            We sent you an email!
        </div>
        <div class="mt-2 p-2 fm-rubik" style="text-align: left;font-size: 1rem;color: #5D5D66;font-weight: 400;">
            Please click on the link we sent you at your email to verify your identity and activate your account
        </div>
        <p-divider></p-divider>
        <div class="fm-rubik">
            <span style="color: #5D5D66;font-size: 0.849rem;">If you didn't get any email:</span>
            <span class="fm-prompt-bold mx-2" style="color: #EF870A;font-weight: bolder;cursor: pointer;" (click)="resendMail()">Send confirmation email
                again</span>
        </div>
    </div>
</p-dialog>
